import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RackViewComponent } from './rack/rack.component';
import { OverheadStorageViewComponent } from './overheadstorage/overheadstorage.component';
import { WallViewComponent } from './wall/wall.component';
import { AdjustableSeatViewComponent } from './seat/seat.component';
import { TableViewComponent } from './table/table.component';
import { NonUseablespaceViewComponent } from './nonuseablespace/nonuseablespace.component';
import { AdvancedPropertyWindowComponent } from './advanced-property-window.component';
import { FormsModule } from '@angular/forms';
import { ModalDialog } from '../Modal/modal';
import { ApplicationPipesModule } from '../pipes/applicationpipes.module';
import { StairViewComponent } from './stair/stair.component';
import { BedViewComponent } from './bed/bed.component';
import { InnerdoorViewComponent } from './innerdoor/innerdoor.component';
import { EntrancedoorViewComponent } from './entrancedoor/entrancedoor.component';
import { GangwaydoorViewComponent } from './gangwaydoor/gangwaydoor.component';
import { SeatwithstorageViewComponent } from './seatwithstorage/seatwithstorage.component';
import { TablewithstorageViewComponent } from './tablewithstorage/tablewithstorage.component';
import { MultiPurposeAreaViewComponent } from './multipurposearea/multipurposearea.component';
import { AisleViewComponent } from './aisle/aisle.component';
import { PTseatViewComponent } from './ptseat/ptseat.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    AdvancedPropertyWindowComponent,
    RackViewComponent,
    OverheadStorageViewComponent,
    WallViewComponent,
    AdjustableSeatViewComponent,
    TableViewComponent,
    NonUseablespaceViewComponent,
    ModalDialog,
    StairViewComponent,
    BedViewComponent,
    InnerdoorViewComponent,
    EntrancedoorViewComponent,
    GangwaydoorViewComponent,
    SeatwithstorageViewComponent,
    TablewithstorageViewComponent,
    AisleViewComponent,
    PTseatViewComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatMenuModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatCardModule,
    MatListModule,
    MatIconModule,
    MatTableModule,
    FormsModule,
    MatDialogModule,
    ApplicationPipesModule.forChild()
  ],
  exports: [AdvancedPropertyWindowComponent]
})
export class AdvancedPropertyModule { }